import React from 'react'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'next-i18next'
import { FeaturedGalleryCard } from './FeaturedGalleryCard'
import styles from './index.module.scss'
import { UiAppearance } from '~/modules/UiVariant/appearance'

export interface FeaturedGalleryDto {
  name: string
  imageUrl: string
  galleryUrl: string
}

interface Props {
  featured: FeaturedGalleryDto[]
  appearance?: UiAppearance
}

const getMuseumHomeImagePosition = (galleryUrl: string): string | undefined => {
  // TODO: Replace these per-athlete overrides with persisted focal points in gallery data.
  if (galleryUrl.includes('/gallery/brunocetraro')) {
    return '50% 24%'
  }

  if (galleryUrl.includes('/gallery/erwinfeuchtmann')) {
    return '52% 22%'
  }

  if (galleryUrl.includes('/gallery/shirleymelz')) {
    return '58% 22%'
  }

  return undefined
}

export const FeaturedGalleries: React.FC<Props> = ({ featured, appearance = 'default' }) => {
  const { t } = useTranslation('featured_galleries')

  const cards = featured.map((f) => {
    return (
      <FeaturedGalleryCard
        key={ f.galleryUrl }
        title={ f.name }
        image={ f.imageUrl }
        gallery={ f.galleryUrl }
        imagePosition={ appearance === 'museumHome' ? getMuseumHomeImagePosition(f.galleryUrl) : undefined }
        appearance={ appearance }
      />
    )
  })

  return (
    <section
      id="featured-galleries"
      className={ `
        ${styles.featuredGalleries__container}
        ${appearance === 'museumHome' ? styles.museumHome : ''}
      ` }
    >
      <div className={ styles.featuredGalleries__header }>
        <h2 className={ styles.featuredGalleries__header__title }>
          { t('header_title') }

          <small className={ styles.featuredGalleries__header__subtitle }>
            { t('header_subtitle') }
          </small>
        </h2>

        <Link
          className={ styles.featuredGalleries__header__link }
          href='/gallery'
          passHref={ true }
        >
          { t('header_see_all') } { }
          <FontAwesomeIcon
            icon={ faArrowUpRightFromSquare }
          />
        </Link>
      </div>

      <div className={ styles.featuredGalleries__list }>
        { cards }
      </div>
    </section>
  )
}
